import { useState, useEffect } from 'react';

export const useMobileDetect = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
    const mobileRegex = /Android.*Mobile|webOS|iPhone|iPod|BlackBerry|Windows Phone|Opera Mini|IEMobile|CriOS/i;
    const userAgentMatches = mobileRegex.test(userAgent);
    const hasTouch =
      'ontouchstart' in window ||
      (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 0);
    setIsMobile(userAgentMatches && hasTouch);
  }, []);

  return isMobile;
};
